// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8c9d9335","180":"591e94a4","208":"a340a806","631":"bf6fe912","774":"65338c52","787":"2e8f9871","820":"63b4d1d6","910":"5bb53778"}[chunkId] + ".chunk.js";
};